import { render, staticRenderFns } from "./StartWorkflowForm.vue?vue&type=template&id=90affe5c&scoped=true&"
import script from "./StartWorkflowForm.vue?vue&type=script&lang=js&"
export * from "./StartWorkflowForm.vue?vue&type=script&lang=js&"
import style0 from "./StartWorkflowForm.vue?vue&type=style&index=0&id=90affe5c&prod&lang=scss&"
import style1 from "./StartWorkflowForm.vue?vue&type=style&index=1&id=90affe5c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90affe5c",
  null
  
)

export default component.exports